import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FangPopoverDirective} from './fang-popover.directive';


@NgModule({
	imports: [
		CommonModule
	],
	exports: [
		FangPopoverDirective
	],
	declarations: [
		FangPopoverDirective
	],
	providers: [],
	entryComponents: []
})
export class FangPopoverModule {
}
